import { useEffect, useState } from 'react';

export function useIsHydrated() {
  const [isHydrated, setIsHydrated] = useState<Boolean>(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
}
